const visibleToothIDs = new Set<string>();

export const setToothSliceCardVisible = (toothID: string) => {
  visibleToothIDs.add(toothID);
};

export const forgetToothSliceCard = (toothID: string) => {
  visibleToothIDs.delete(toothID);
};

export const isToothSliceCardVisible = (toothID: string) =>
  visibleToothIDs.has(toothID);
